import styled from 'styled-components';

export const Container = styled.div`
  .card {
    border-radius: 20px;
  }

  .resumo-compra {
    font-size: 18px;
    line-height: 21px;
  }

  .info-assinatura {
    font-size: 12px;
    line-height: 14px;
  }
`;
